import Webinar from '@/components/webinar';

const RegistrationWebinar = () => import(/* webpackChunkName: "registration" */ '@/components/registration/registration-webinar');
const RegistrationForm = () => import(/* webpackChunkName: "registration" */ '@/components/registration/registration-form');
const RegistrationConfirmation = () => import(/* webpackChunkName: "registration" */ '@/components/registration/registration-confirmation');
const Hallway = () => import(/* webpackChunkName: "hallway" */ '@/components/hallway');
const Attendance = () => import(/* webpackChunkName: "attendance" */ '@/components/attendance/attendance');
const RecordingViewer = () => import(/* wepackChunkName: "recording" */ '@/components/recording/recording-viewer');
const Survey = () => import(/* webpackChunkName: "survey" */ '@/components/survey');

export default {
  path: 'webinar/:webinarKey',
  component: Webinar,
  props: true,
  children: [
    {
      // webinar/:webinarKey/register
      path: 'register',
      component: RegistrationWebinar,
      props: true,
      children: [
        {
          path: '',
          name: 'registration',
          component: RegistrationForm,
          props: true
        },
        {
          // webinar/:webinarKey/register/:registrantKey
          path: ':registrantKey',
          name: 'registration-confirmation',
          component: RegistrationConfirmation,
          props: true
        }
      ]
    },
    {
      // webinar/:webinarKey/wait/:registrantKey
      path: 'wait/:registrantKey',
      name: 'hallway',
      component: Hallway,
      props: true
    },
    {
      // webinar/:webinarKey/preview
      path: 'preview',
      name: 'preview',
      component: Attendance,
      props: (route) => ({
        webinarKey: route.params.webinarKey,
        registrantKey: route.params.registrantKey,
        preview: true
      })
    },
    {
      // webinar/:webinarKey/attend/:registrantKey
      path: 'attend/:registrantKey',
      name: 'attendance',
      component: Attendance,
      props: true
    },
    {
      // webinar/:webinarKey/view/:recordingKey/:registrantKey
      path: 'view/:recordingKey/:registrantKey',
      name: 'view-webinar-recording',
      component: RecordingViewer,
      props: true
    },
    {
      // webinar/:webinarKey/survey/:registrantKey
      path: 'survey/:registrantKey',
      name: 'survey',
      component: Survey,
      props: true
    }
  ]
};
